import React from 'react'

const ClockIconLined = () => {
    return (
        <svg
            // width="24" height="24"
            style={{ width: '100%' }}
            viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="12" cy="12" r="10" stroke="#2B3F6C" stroke-width="1.5" />
            <path opacity="0.3" d="M12 8V11.7324C12 11.8996 12.0836 12.0557 12.2226 12.1484L15 14" stroke="#2B3F6C" stroke-width="1.5" stroke-linecap="round" />
        </svg>


    )
}

export default ClockIconLined